/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderWorkbookItemsRequestDto
 */
export interface ReorderWorkbookItemsRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ReorderWorkbookItemsRequestDto
     */
    workbookId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReorderWorkbookItemsRequestDto
     */
    orderedItemIds?: Array<string> | null;
}

/**
 * Check if a given object implements the ReorderWorkbookItemsRequestDto interface.
 */
export function instanceOfReorderWorkbookItemsRequestDto(value: object): value is ReorderWorkbookItemsRequestDto {
    return true;
}

export function ReorderWorkbookItemsRequestDtoFromJSON(json: any): ReorderWorkbookItemsRequestDto {
    return ReorderWorkbookItemsRequestDtoFromJSONTyped(json, false);
}

export function ReorderWorkbookItemsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderWorkbookItemsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workbookId': json['workbookId'] == null ? undefined : json['workbookId'],
        'orderedItemIds': json['orderedItemIds'] == null ? undefined : json['orderedItemIds'],
    };
}

export function ReorderWorkbookItemsRequestDtoToJSON(json: any): ReorderWorkbookItemsRequestDto {
    return ReorderWorkbookItemsRequestDtoToJSONTyped(json, false);
}

export function ReorderWorkbookItemsRequestDtoToJSONTyped(value?: ReorderWorkbookItemsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workbookId': value['workbookId'],
        'orderedItemIds': value['orderedItemIds'],
    };
}

